import { TextType } from '@/player-config/src/types/asset-types';
import { TextAsset } from '@/Pages/PostsListPage/types';

export const getPostType = (post: TextAsset | null): TextType | null => {
  return post?.asset_metadata?.type ?? null;
};

export const getSocialClipId = (post: TextAsset | null): string | null => {
  if (!post?.asset_metadata) {
    return null;
  }
  const { clip_asset_ids, currentClipIndex, activeClipIndex } = post?.asset_metadata || {};
  if (!clip_asset_ids?.length) {
    return null;
  }
  const selectedClipIndex = currentClipIndex ?? activeClipIndex;
  if (typeof selectedClipIndex !== 'number') {
    return clip_asset_ids?.[0] ?? null;
  }
  return clip_asset_ids?.[selectedClipIndex] ?? null;
};

export const getBlogAssetIds = (post: TextAsset | null): string[] | null => {
  if (!post?.asset_metadata) {
    return null;
  }
  const { clip_assets } = post?.asset_metadata || {};
  if (!clip_assets?.length) {
    return null;
  }
  return clip_assets;
};
